const formatDateForInput = (dateString) => {
    if (!dateString) {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }

    try {
        // If date is already in YYYY-MM-DD format
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }

        // If date includes time and timezone
        // Split by 'T' to get date part only
        const datePart = dateString.split('T')[0];
        if (datePart && /^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
            return datePart;
        }

        // Try parsing as date object
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        const today = new Date();
        return today.toISOString().split('T')[0];
    }
};

export default formatDateForInput;